export const EXTRACT_DOWNLOAD_LINK = "/HIGHBS-BOK 1 (extrait).pdf"
